import { createFileRoute } from "@tanstack/react-router";

import { TermsOfServicePage } from "../terms-of-service";

export const Route = createFileRoute("/en/terms-of-service")({
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=86400, stale-while-revalidate=604800",
	}),
	head: () => ({
		meta: [
			{ title: "Terms of Service | Makedonijaturist AD" },
			{
				name: "description",
				content:
					"Terms of Service for the Makedonijaturist AD website. Rules and regulations for accessing and using our services.",
			},
			{
				name: "robots",
				content: "noindex, follow",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en/terms-of-service",
			},
		],
	}),
	component: TermsOfServicePage,
});
